<template>
  <div>
    <AppTable :rows="localChairs" resourceName="Department Chairs">
      <template #header>
        <th class="th">First Name</th>
        <th class="th">Last Name</th>
        <th class="th">Email</th>
      </template>
      <template #default="{ row: chair, key: chairIndex }">
        <td>
          <FormText
            :value="chair.firstName"
            placeholder="First Name"
            :disabled="!editable"
            @input="setChairAttribute(chairIndex, 'firstName', $event)"
          />
        </td>
        <td>
          <FormText
            :value="chair.lastName"
            placeholder="Last Name"
            :disabled="!editable"
            @input="setChairAttribute(chairIndex, 'lastName', $event)"
          />
        </td>
        <td class="d-flex">
          <FormText
            :value="chair.email"
            placeholder="Email"
            :disabled="!editable"
            class="flex-1"
            @input="setChairAttribute(chairIndex, 'email', $event)"
          />
          <AppButton
            v-if="editable"
            variant="danger"
            @click="deleteChair(chairIndex)"
          >
            <AppIcon name="delete" />
          </AppButton>
        </td>
      </template>
    </AppTable>
    <AppButton v-if="editable" @click="addChair">
      <AppIcon name="add" />
      Add Chair
    </AppButton>
  </div>
</template>
<script>
import _clonedeep from 'lodash/cloneDeep'
import FormText from '@/components/Forms/FormText'
export default {
  components: { FormText },
  props: {
    chairs: {
      type: Array,
      default: () => [],
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return { localChairs: {} }
  },
  created () {
    this.localChairs = _clonedeep(this.chairs)
  },
  methods: {
    addChair () {
      this.localChairs.push({
        firstName: '',
        lastName: '',
        email: '',
      })
      this.$emit('update', this.localChairs)
    },
    setChairAttribute (chairIndex, key, value) {
      this.localChairs[chairIndex][key] = value
      this.$emit('update', this.localChairs)
    },
    deleteChair (chairIndex) {
      this.localChairs.splice(chairIndex, 1)
      this.$emit('update', this.localChairs)
    },
  },
}
</script>
